<template>
    <section class="services-sec">
        <div class="container">
            <div class="row">
                <div v-for="(service, index) in service_list" v-bind:key="index" class="col-lg-3 col-md-4 col-sm-6">
                    <router-link v-if="!service.isNewTab" :to="service.url" class="service-card-1__link">
                        <div class="service-card-1" :class="service.color_class">
                            <div class="media">
                                <div class="service-card__icon-sec align-self-center">
                                    <span class="service-card__icon  " :class="'icon-'+service.icon"></span>
                                </div>
                                <div class="media-body align-self-center">
                                    <h3 class="service-card-1__title m-0">{{service.title}}</h3>
                                </div>
                            </div>
                        </div>
                    </router-link>
                    <a v-else :href="service.url" target="_blank" class="service-card-1__link">
                        <div class="service-card-1" :class="service.color_class">
                            <div class="media">
                                <div class="service-card__icon-sec align-self-center">
                                    <span class="service-card__icon  " :class="'icon-'+service.icon"></span>
                                </div>
                                <div class="media-body align-self-center">
                                    <h3 class="service-card-1__title m-0">{{service.title}}</h3>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "HomeServicesSec",
        data() {
            return {
                service_list: [

                    { "isNewTab": false,"icon": "EU-1", "title": "Веза са правним актима ЕУ", "color_class": "color-1", "url": "/fp/eurlex"},
                    { "isNewTab": false,"icon": "Korisni-linkovi", "title": "Корисни линкови", "color_class": "color-2", "url": "/fp/useful-links-state"},
                    { "isNewTab": false,"icon": "eli_logo", "title": "Европска ознака законодавства", "color_class": "color-3", "url": "/evropska-oznaka-zakonodavstva"},
                    { "isNewTab": false,"icon": "presentation-1", "title": "Упит за презентацију", "color_class": "color-4", "url": "/fp/presentation-query"},
                    { "isNewTab": false,"icon": "calculator-1", "title": "Калкулатор", "color_class": "color-5", "url": "/calc/zatezne-kamate"},
                    { "isNewTab": false,"icon": "Statistika-1", "title": "Статистика", "color_class": "color-6", "url": "fp/statistics"},
                    { "isNewTab": false,"icon": "Novosti-1", "title": "Претрага малих огласа", "color_class": "color-7", "url": "/fp/pretraga-nevazecih-isprava"},
                    { "isNewTab": true, "icon": "wallet-1", "title": "Претплата", "color_class": "color-8", "url": "https://slglasnik.com/usluge/pretplata"},

                ]
            }
        }
    }
</script>

<style scoped>

</style>
